import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Best-effort calls (e.g. mediator analytics) pass skipAuthRedirect so a 401
    // from them never bounces the user to /login. A 401 from a /scale-proxy/ call
    // is a Scale-backend rejection passed through cm-be, NOT the case manager's own
    // session dying, so it must not log out either — a genuine session failure is
    // still caught by the page's core cm-be requests.
    const reqUrl = error.config?.url || '';
    const isScaleProxy = reqUrl.includes('/scale-proxy/');
    if (
      error.response?.status === 401 &&
      !error.config?.skipAuthRedirect &&
      !isScaleProxy
    ) {
      const isLoginPage = window.location.pathname === '/login';
      if (!isLoginPage) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
